const locales = [
  { name: 'Português - Brasil', code: 'pt-br', iso: 'pt-BR', file: 'pt-br.js' },
  { name: 'English', code: 'en', iso: 'en', file: 'en.js' },
  { name: 'Español - España', code: 'es', iso: 'es-ES', file: 'es.js' },
  { name: 'Español - España', code: 'es-es', iso: 'es-ES', file: 'es-es.js', hidden: true },
  { name: 'Español - Colombia', code: 'es-co', iso: 'es-CO', file: 'es-co.js', hidden: true },
  { name: 'Español - Colombia', code: 'co', iso: 'es-CO', file: 'co.js' },
  { name: 'Español - México', code: 'es-mx', iso: 'es-MX', file: 'es-mx.js', hidden: true },
  { name: 'Español - México', code: 'mx', iso: 'es-MX', file: 'mx.js' },
  { name: 'Español - América Latina', code: 'la', iso: 'es-419', file: 'la.js' },
]

export default locales
